import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

export const AddPolicyFormSchema = z.object({
  policyNumber: z.number().optional(),
  policyUri: z.string().min(1, 'Policy URI is required').max(500),
  version: z.string().min(1, 'Version is required').max(20),
  role: z.string().min(1, 'Role is required'),
  allow: z.array(z.string()).default([]),
  deny: z.array(z.string()).default([]),
  // net-new field — requires backend API contract confirmation before shipping
  resourceInstances: z.array(z.string()).optional().default([]),
  conditions: z.record(z.string(), z.string()).default({}),
})

export type AddPolicyFormData = z.infer<typeof AddPolicyFormSchema>

export function transformToApiRequest(formData: AddPolicyFormData) {
  return {
    policyNumber: formData.policyNumber,
    policyUri: formData.policyUri.trim(),
    version: formData.version.trim(),
    role: formData.role.trim(),
    allow: formData.allow,
    deny: formData.deny,
    resourceInstances: formData.resourceInstances ?? [],
    conditions: formData.conditions,
  }
}
